import Ticker from './Ticker'
import Observer from "../../../services/helpers/Observer";
import { cloneCanvas } from '../generate-quick-download/html-banner/helpers';
import NodesList from './NodesList';
import Node from './Node';

const DEFAULT_FPS = 15;

export default class Player {

    _currentNumberOfLoops = 1;

    numberOfLoops = null;
    canvas = null;
    ticker = null;
    nodesList = null;
    observer = new Observer();

    constructor(canvas) {
        this.ticker = new Ticker();
        this.canvas = canvas;
        this._initTickerEvents();
    }

    _initTickerEvents() {
        this.ticker.observer.on({
            progressing: (time) => {
               this._renderFrame(time);
            },
            ended: () => {
                if (this.numberOfLoops === null) {
                    this.reset();
                } else if (this.numberOfLoops === '') {
                    this.play();
                } else if (this._currentNumberOfLoops >= this.numberOfLoops) {
                    this.reset();
                } else {
                    this.play();
                    this._currentNumberOfLoops++;
                }
            }
        })
    }

    _renderFrame(time) {
        this.nodesList.render(time);
        this.canvas.renderAll();
    }

    _setShowAllNodes(isShow = true) {
        this.nodesList.setShowAll(isShow);
        this.canvas.renderAll();
    }

    initNodes(nodesData = []) {
        const nodes = nodesData.filter(node => node.isPlay).map((node) => {
            const objects = this.canvas.getObjects();
            const object = objects.find(obj => obj.id === node.objectId);

            return new Node({ ...node, object });
        });

        this.nodesList = new NodesList(nodes);

        this.ticker.setEnd(this.nodesList.getMaxEndTime());
        
        return this;
    }

    setTime(time) {
        this.ticker.setCurrentTime(time);
    }

    setNumberOfLoops(count = null) {
        this.numberOfLoops = count;
    }

    getMaxEndTime() {
        return this.nodesList.getMaxEndTime();
    }

    async getCanvasFrames(calback) {
        let times = this.nodesList.nodes.reduce((acc, node) => {
            return [...acc, ...node.getTimesShowFrames()];
        }, []);
        times = _.uniq(times);
        times = _.sortBy(times);

        if (!times.length) {
            const canvas = cloneCanvas(this.canvas.lowerCanvasEl);
            await calback(canvas, 0);

            return;
        }

        for (let i = 0; i < times.length; i++) {
            const time = times[i];
            const duration = (times[i + 1] - time) || 0;

            this.setTime(time);
            const canvas = cloneCanvas(this.canvas.lowerCanvasEl);
            await calback(canvas, duration);
        }
    }

    play() {
        this.canvas.discardActiveObject();
        this.ticker.start()
    }

    pause() {
        this.ticker.stop();
    }

    reset() {
        this.ticker.reset()

        if (this.numberOfLoops === null) {
            this._setShowAllNodes();
        }
    }
}

